// components/SwitchProfileModal.jsx
import React from 'react';

const SwitchProfileModal = ({ 
  isOpen, 
  onClose, 
  users, 
  selectedKey, 
  tempSelectedUser, 
  setTempSelectedUser, 
  onConfirm 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      {/* Backdrop with whitish blur */}
      <div 
        className="absolute inset-0 bg-white/40 backdrop-blur-md"
        onClick={onClose}
      />
      
      {/* Modal Card */}
      <div className="relative bg-white rounded-2xl border-[1.5px]  border-primary-blue shadow-2xl w-full max-w-[25rem] 2xl:max-w-md">
        {/* Header with centered title */}
        <div className="relative px-8 pt-6 pb-5">
          <h2 className="text-xl font-semibold text-gray-900 text-center">
            Switch Profile
          </h2>
          <button
            onClick={onClose}
            className="absolute right-6 top-6 hover:opacity-70 transition-opacity"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#9CA3AF" strokeWidth="2" fill="none"/>
              <path d="M8 8L16 16M16 8L8 16" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {/* Profile List with custom scrollbar - Fixed height for exactly 3 items */}
        <div className="px-8 pb-5 max-h-[240px] overflow-y-auto scrollbar-hide">
               <style>{`
      .scrollbar-hide::-webkit-scrollbar {
        display: none;
      }
      .scrollbar-hide {
        -ms-overflow-style: none;
        scrollbar-width: none;
      }
    `}</style>
          <div className="space-y-3">
            {users.map((u) => {
              const key = u.sub_username || String(u.id || u.user_bid_id || u.document_id || '');
              const label = u.sub_username ?? u.username ?? u.name ?? `User ${key}`;
              const isSelected = String(tempSelectedUser) === String(key);

              return (
                <label
                  key={String(key)}
                  className={`flex items-center gap-3 px-4 py-3.5 border-[1.5px]  rounded-xl cursor-pointer transition-all ${
                    isSelected
                      ? 'border-primary-blue bg-blue-50'
                      : 'border-primary-blue hover:bg-gray-50 bg-white'
                  }`}
                >
                  <div className="relative flex items-center justify-center flex-shrink-0">
                    <input
                      type="radio"
                      name="profile"
                      value={String(key)}
                      checked={isSelected}
                      onChange={(e) => setTempSelectedUser(e.target.value)}
                      className="sr-only"
                    />
                    <div className={`w-6 h-6 rounded-full border-[1.5px]  flex items-center justify-center ${
                      isSelected ? 'border-primary-blue' : 'border-gray-400'
                    }`}>
                      {isSelected && (
                        <div className="w-3 h-3 rounded-full bg-primary-blue" />
                      )}
                    </div>
                  </div>
                  <span className="text-sm font-medium text-gray-700">{label}</span>
                </label>
              );
            })}
          </div>
        </div>

        {/* Switch Button */}
        <div className="px-8 pb-6 pt-1 w-64 2xl:w-72 mx-auto">
          <button
            onClick={onConfirm}
            disabled={!tempSelectedUser}
            className="w-full py-3 bg-primary-blue text-white font-semibold rounded-lg hover:bg-primary-blue/60 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-base"
          >
            Switch
          </button>
        </div>
      </div>

    </div>
  );
};

export default SwitchProfileModal;
